'use client';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { supabaseBrowser } from '@/lib/supabaseBrowser';

export default function AuthButtons() {
  const supabase = supabaseBrowser();
  const router = useRouter();
  const [loading, setLoading] = useState(true);
  const [signedIn, setSignedIn] = useState(false);

  useEffect(() => {
    let mounted = true;

    async function init() {
      const { data: { session } } = await supabase.auth.getSession();
      if (!mounted) return;
      setSignedIn(!!session?.user);
      setLoading(false);
    }

    init();

    const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
      if (!mounted) return;
      if (event === 'SIGNED_OUT') {
        setSignedIn(false);
        setLoading(false);
        router.push('/');
        router.refresh();
      } else if (event === 'SIGNED_IN') {
        setSignedIn(true);
        setLoading(false);
      } else {
        setSignedIn(!!session?.user);
      }
    });

    return () => {
      mounted = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  async function logout() {
    await supabase.auth.signOut({ scope: 'local' });
    window.location.replace('/');
  }

  if (loading) return null;

  if (signedIn) {
    return (
      <button onClick={logout} className="btn btn-ghost">
        Log out
      </button>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <button
        onClick={() => { window.location.href = '/login?mode=signin'; }}
        className="btn btn-ghost"
      >
        Log in
      </button>
      <button
        onClick={() => { window.location.href = '/login?mode=signup'; }}
        className="btn btn-primary"
      >
        Sign up
      </button>
    </div>
  );
}
